export const FILTROS_INICIAIS = {
  soc_percentual: 'setpar',
  periodos: ['atual'],
  ge: [],
  empreendimentos: [],
  cobranca: [],
  tipos_parcela: [],
};

const criarRangeAnos = (inicio, fim) => {
  const anos = [];
  for (let ano = inicio; ano <= fim; ano += 1) {
    anos.push(ano);
  }
  return anos;
};

const criarPeriodo = (value, label, inicio, fim) => ({
  value,
  label,
  inicio,
  fim,
  anos: criarRangeAnos(inicio, fim),
  tipo: 'periodo',
});

const PERIODOS_RANGE_OPTIONS = [
  criarPeriodo('2025-2029', '2025 a 2029', 2025, 2029),
  criarPeriodo('2030-2034', '2030 a 2034', 2030, 2034),
  criarPeriodo('2035-2039', '2035 a 2039', 2035, 2039),
  criarPeriodo('2040-2044', '2040 a 2044', 2040, 2044),
  criarPeriodo('2045-2049', '2045 a 2049', 2045, 2049),
  criarPeriodo('2050-2054', '2050 a 2054', 2050, 2054),
];

const ANO_ATUAL = new Date().getFullYear();

const criarPeriodoAtual = () => {
  const periodoAtual = PERIODOS_RANGE_OPTIONS.find(
    periodo => ANO_ATUAL >= periodo.inicio && ANO_ATUAL <= periodo.fim
  );
  const anoFinal = periodoAtual ? periodoAtual.fim : ANO_ATUAL;

  return {
    value: 'atual',
    label: 'Atual',
    anos: criarRangeAnos(ANO_ATUAL, anoFinal),
    tipo: 'periodo',
  };
};

const PERIODO_ATUAL = criarPeriodoAtual();
const ANO_FINAL_PERIODO_ATUAL =
  PERIODO_ATUAL.anos[PERIODO_ATUAL.anos.length - 1];

export const PERIODOS_OPTIONS = [
  PERIODO_ATUAL,
  ...PERIODOS_RANGE_OPTIONS.filter(
    periodo => periodo.inicio > ANO_FINAL_PERIODO_ATUAL
  ),
];

export const PERIODOS_SELECT_OPTIONS = PERIODOS_OPTIONS.reduce(
  (options, periodo) => {
    options.push(periodo);
    periodo.anos.forEach(ano => {
      options.push({
        value: `${periodo.value}:${ano}`,
        label: `${ano}`,
        ano,
        parent: periodo.value,
        tipo: 'ano',
      });
    });
    return options;
  },
  []
);

export const PERCENTUAIS_REFERENCIA = [
  { value: 0.15, label: '0,15' },
  { value: 0.3, label: '0,30' },
  { value: 0.45, label: '0,45' },
  { value: 0.6, label: '0,60' },
  { value: 0.75, label: '0,75' },
  { value: 0.9, label: '0,90' },
  { value: 1, label: '1,00' },
];

const expandirPeriodos = periodos => {
  const selecionados = normalizarLista(periodos);
  const anos = [];

  selecionados.forEach(periodo => {
    const opcao = PERIODOS_OPTIONS.find(item => item.value === periodo);
    if (opcao) {
      anos.push(...opcao.anos);
      return;
    }

    const opcaoAno = PERIODOS_SELECT_OPTIONS.find(
      item => item.value === periodo && item.tipo === 'ano'
    );
    if (opcaoAno) {
      anos.push(opcaoAno.ano);
      return;
    }

    const ano = Number(periodo);
    if (!Number.isNaN(ano)) {
      anos.push(ano);
    }
  });

  return anos.filter((ano, index) => anos.indexOf(ano) === index);
};

export const montarPayloadFiltro = values => {
  const periodos = expandirPeriodos(values.periodos);

  return {
    soc_percentual: values.soc_percentual,
    periodos: periodos.length > 0 ? periodos : null,
    ge: values.ge && values.ge.length > 0 ? values.ge : null,
    empreendimentos:
      values.empreendimentos && values.empreendimentos.length > 0
        ? values.empreendimentos
        : null,
    cobranca:
      values.cobranca && values.cobranca.length > 0 ? values.cobranca : null,
    tipos_parcela:
      values.tipos_parcela && values.tipos_parcela.length > 0
        ? values.tipos_parcela
        : null,
  };
};

const normalizarValoresChave = valores =>
  normalizarLista(valores)
    .map(valor => `${valor}`)
    .sort();

export const criarChaveFiltros = filtros =>
  JSON.stringify({
    soc_percentual:
      filtros && filtros.soc_percentual ? filtros.soc_percentual : 'setpar',
    periodos: normalizarValoresChave(filtros && filtros.periodos),
    ge: normalizarValoresChave(filtros && filtros.ge),
    empreendimentos: normalizarValoresChave(
      filtros && filtros.empreendimentos
    ),
    cobranca: normalizarValoresChave(filtros && filtros.cobranca),
    tipos_parcela: normalizarValoresChave(filtros && filtros.tipos_parcela),
  });

export const getMensagemErro = (err, fallback) =>
  err && err.message ? err.message : fallback;

export const formatarMoeda = valor => {
  if (valor == null || Number.isNaN(Number(valor))) return '-';
  return Number(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const formatarNumero = valor => {
  if (valor == null || Number.isNaN(Number(valor))) return '-';
  return Number(valor).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatarMoedaCompacta = valor => {
  if (valor == null || Number.isNaN(Number(valor))) return '-';

  const numero = Number(valor);
  const absoluto = Math.abs(numero);

  if (absoluto >= 1000000000) {
    return `${(numero / 1000000000).toLocaleString('pt-BR', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })} Bi`;
  }

  if (absoluto >= 1000000) {
    return `${(numero / 1000000).toLocaleString('pt-BR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })} Mi`;
  }

  return formatarMoeda(valor);
};

export const formatarPercentual = valor => {
  if (valor == null || Number.isNaN(Number(valor))) return '-';
  return `${(Number(valor) * 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
};

export const formatarDataCarga = valor => {
  if (!valor) return '-';
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return '-';
  return data.toLocaleString('pt-BR');
};

export const normalizarLista = lista => (Array.isArray(lista) ? lista : []);

export const optionFromString = valor => ({
  value: valor,
  label: `${valor}`,
});

export const optionFromEmpreendimento = item => ({
  value: item.codigo,
  label: `${item.codigo} - ${item.nome}`,
});

export const selecionarOptions = (options, values) => {
  const selecionados = values || [];
  return options.filter(option => selecionados.indexOf(option.value) !== -1);
};

export const montarLinhasExcel = (linhas, colunas) =>
  normalizarLista(linhas).map(item => {
    const linha = {};
    colunas.forEach(coluna => {
      linha[coluna.title] =
        typeof coluna.excel === 'function'
          ? coluna.excel(item)
          : item[coluna.key];
    });
    return linha;
  });
